import { defineComponent as _defineComponent } from 'vue'
import FloatingActionButton from "@/components/buttons/FloatingActionButton.vue";

import {
  computed,
  onMounted,
  PropType,
  ref,
  unref,
  watch,
} from "vue";

import {
  mailLength,
  paycardNumberLength,
} from "@/scripts/Common/constraints/constraints";

import {
  isBiggerOrEqualToMinLength,
  isRequired,
  isSmallerOrEqualToMaxLength,
  isValidEmail,
} from "@/scripts/Common/validators/defaultValidator";

import {
  copyObject,
} from "@/scripts/Common/HelperFunctions";

import type {
  CardUser,
} from "@/components/cardUsers/scripts";

import {
  createOrUpdateCardUser,
  fetchCardUsers,
  selectCardUser,
  createEmptyCardUser,
  cardUserHasChanges,
  CARD_USER_ID_STORAGE_KEY,
} from "@/components/cardUsers/scripts";

import {
  httpMethod,
} from "@/scripts/Common/api";

import {
  getNumberItemFromStorage,
  saveItemToStorage,
} from "@/scripts/Common/componentStorage";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardUserCoreData',
  props: {
  hasEditRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  startInCreationMode: {
    required: true,
    type: Boolean as PropType<boolean>
  }
},
  emits: [
  'onFetchError'
],
  setup(__props, { emit: emits }) {

const props = __props;





const comboSelection = ref<CardUser | undefined>();
const cardUsers = ref<CardUser[]>([]);
const cardUserForm = ref();

const selectedCardUser = ref<CardUser>(createEmptyCardUser());
const initialCardUserData = ref<CardUser>(createEmptyCardUser());

const hasNoEditRights = !props.hasEditRights;
const isValid = ref<boolean>(true);
const addressValid = ref<boolean>(true);
const isCreationMode = ref<boolean>(false);

const canSave = computed(() => {
  return isValid.value
    && addressValid.value
    && cardUserHasChanges(unref(initialCardUserData), unref(selectedCardUser));
});

const onHandleFetchError = ({error}: { error: any }) => {
  emits('onFetchError', {error})
};

const hasCardUsers = computed(() => {
  return cardUsers.value && cardUsers.value.length > 0;
})

const comboboxIsActive = computed(() => {
  if (!hasCardUsers.value) return false;

  return !isCreationMode.value;
})

const canReset = computed(() => {
  return cardUserHasChanges(unref(initialCardUserData), unref(selectedCardUser)) || (hasCardUsers.value && isCreationMode.value);
})

const loadCardUsers = async () => {
  const {response, error} = await fetchCardUsers();

  if (error || !response) {
    onHandleFetchError({error});
    return;
  }

  cardUsers.value = response;
  selectedCardUser.value = selectCardUser(unref(cardUsers), getNumberItemFromStorage(CARD_USER_ID_STORAGE_KEY))
  initialCardUserData.value = copyObject(selectedCardUser.value);
  comboSelection.value = selectedCardUser.value
}

const validate = () => {
  cardUserForm.value.validate();
}

const onHandleSetupEmptyCardUser = () => {
  isCreationMode.value = true;
  selectedCardUser.value = createEmptyCardUser();
  initialCardUserData.value = createEmptyCardUser();
  validate();
}

const updateCardUserInformation = async () => {
  const {error} = await createOrUpdateCardUser(unref(selectedCardUser), httpMethod.PUT);

  if (error) {
    onHandleFetchError({error});
    return;
  }

  loadCardUsers();
}

const createNewCardUserInformation = async () => {
  const {error, response} = await createOrUpdateCardUser(unref(selectedCardUser), httpMethod.POST);

  if (error || !response) {
    onHandleFetchError({error});
    return;
  }

  isCreationMode.value = false;
  saveItemToStorage(response, CARD_USER_ID_STORAGE_KEY);
  loadCardUsers();
}

const onHandleCreateOrUpdateCardUser = async () => {
  selectedCardUser.value.id === 0
    ? await createNewCardUserInformation()
    : await updateCardUserInformation()
}

const onHandleResetCardUser = () => {
  isCreationMode.value = false;
  loadCardUsers();
}

const onHandleSelectionChange = () => {
  const userId = comboSelection.value?.id;
  if (!userId) return;
  saveItemToStorage(userId, CARD_USER_ID_STORAGE_KEY);
}

watch(comboSelection, () => {
  if (comboSelection.value) {
    selectedCardUser.value = comboSelection.value;
    initialCardUserData.value = copyObject(selectedCardUser.value);
  }
});

onMounted(async () => {
  await loadCardUsers();

  if (props.startInCreationMode || !hasCardUsers.value) {
    onHandleSetupEmptyCardUser();
  }
});

return { __sfc: true,props, emits, comboSelection, cardUsers, cardUserForm, selectedCardUser, initialCardUserData, hasNoEditRights, isValid, addressValid, isCreationMode, canSave, onHandleFetchError, hasCardUsers, comboboxIsActive, canReset, loadCardUsers, validate, onHandleSetupEmptyCardUser, updateCardUserInformation, createNewCardUserInformation, onHandleCreateOrUpdateCardUser, onHandleResetCardUser, onHandleSelectionChange, FloatingActionButton, mailLength, paycardNumberLength, isBiggerOrEqualToMinLength, isRequired, isSmallerOrEqualToMaxLength, isValidEmail }
}

})